import { SectionTable } from '@sbercloud/uikit-product-site-section';
import cn from 'classnames';
import { useLayoutType } from 'src/hooks/useLayoutType';

import { CheckFillSVG } from '../icons/ContentIcons/UIWeb/Round/CheckFill';
import { CrossSVG } from '../icons/ContentIcons/UIWeb/Round/Cross';
import s from './Table.module.scss';

export interface TableProps {
  id?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  withHeader?: boolean;
  withFooter?: boolean;
  rows: string[][];
  isComparison?: boolean;
}

export function Table({
  id,
  title,
  subtitle,
  description,
  withHeader = true,
  withFooter = false,
  rows,
  isComparison,
}: TableProps) {
  const layoutType = useLayoutType();

  return (
    <SectionTable
      id={id}
      layoutType={layoutType}
      title={title}
      subtitle={subtitle}
      description={description}
      withHeader={withHeader}
      rows={rows.map((row, index) => {
        const isFooter = withFooter && index === rows.length - 1;

        const cellInHeader = withHeader && index === 0;

        if (!isComparison || cellInHeader) {
          return row.map((cell) => ({
            content: cell,
            className: cn({ [s.footer]: isFooter }),
          }));
        }

        return row.map((text, index) => {
          const isChecked = Number(text);
          const isFirstCell = index === 0;

          let content;
          if (isFirstCell) {
            content = text;
          }
          if (!isFirstCell && isChecked) {
            content = <CheckFillSVG className={s.checked} />;
          }
          if (!isFirstCell && !isChecked) {
            content = <CrossSVG className={s.unchecked} />;
          }

          return {
            content,
            className: cn({
              [s.comparison]: !isFirstCell,
              [s.footer]: isFooter,
            }),
          };
        });
      })}
    />
  );
}
